module.exports = __webpack_public_path__ + "media/images/weo-ukraine-d1758fac3bd389aaf7cb278ee73c798f.svg";